import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["options"];
import { registerQuery } from 'data-fetching-client';
import get from 'hs-lodash/get';
import without from 'hs-lodash/without';
import http from 'hub-http/clients/apiClient';
const externalDataOptionsFieldName = 'automationUiActionFeatures_externalDataOptions';
export const getExternalDataOptionsResults = data => get(data, externalDataOptionsFieldName);
const args = ['actionTypeId', 'dependentFieldsUniqueKey', 'fieldName', 'flowId', 'initialValue', 'inputActionName', 'nextPageKey', 'objectTypeId', 'query'];
const CLIENT_TIMEOUT = 32000;

/**
 * This is only used for debugging purposes and RequestContext requires a
 * `workflowId` so don't break the query if `flowId` doesn't exist.
 */
const getRequestContext = flowId => flowId ? {
  source: 'WORKFLOWS',
  workflowId: flowId
} : undefined;
export const GET_EXTERNAL_DATA_OPTIONS = registerQuery({
  fieldName: externalDataOptionsFieldName,
  args,
  fetcher: ({
    actionTypeId,
    dependentFields,
    initialValue,
    inputActionName,
    fieldName,
    flowId,
    nextPageKey,
    objectTypeId,
    query
  }) => {
    const buildPostOptions = hydratedFields => ({
      query: {
        clienttimeout: CLIENT_TIMEOUT
      },
      timeout: CLIENT_TIMEOUT + 1000,
      // We want the underlying BE client request to time out before the hub-http request does
      data: {
        actionTypeId,
        extensionDefinitionVersionId: 1,
        // Not used in AAv4
        fieldFetchOptions: {
          after: nextPageKey,
          q: query
        },
        fieldKeyToFetch: fieldName,
        hydratedFields,
        initialValue,
        inputActionName,
        objectTypeId,
        requestContext: getRequestContext(flowId)
      }
    });
    const formatResponse = response => {
      if (response['@result'] !== 'OK') return response;
      const {
          options
        } = response,
        rest = _objectWithoutPropertiesLoose(response, _excluded);
      const optionsByValue = new Map();
      options.forEach(option => optionsByValue.set(option.value, option));
      return Object.assign({}, rest, {
        optionsByValue
      });
    };
    return http.post('automationextensions2/v2/options/fetch', buildPostOptions(dependentFields)).then(formatResponse);
  }
});
export const externalDataOptionsQueryFieldPolicy = {
  [externalDataOptionsFieldName]: {
    keyArgs: without(args, 'nextPageKey'),
    merge(existing, incoming) {
      if (!existing || incoming['@result'] === 'ERR') return incoming;
      if (existing['@result'] === 'ERR') return existing;
      return Object.assign({}, incoming, {
        optionsByValue: new Map([...existing.optionsByValue, ...incoming.optionsByValue])
      });
    }
  }
};